import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import ZoneOverviewView from './views/ZoneOverviewView.vue'
import TournamentsView from './views/TournamentsView.vue'
import TournamentHistoryView from './views/TournamentHistoryView.vue'
import MatchingView from './views/MatchingView.vue'
import ResultView from './views/ResultView.vue'
import ErrorView from './views/ErrorView.vue'
import MInfoAndHelp from '@/modules/MInfoAndHelp.vue'
import { LocalStore, User } from '@gd/storage'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'zone-overview',
    component: ZoneOverviewView,
  },
  {
    path: '/tournaments/:zoneId/:tId?',
    props: { default: true },
    name: 'tournaments',
    components: {
      default: TournamentsView,
      helpSection: MInfoAndHelp,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/TournamentsView.vue')
  },
  {
    path: '/matching/:zoneId/:tId',
    name: 'matching',
    component: MatchingView,
    props: true,
  },
  {
    path: '/result/:competitionId',
    props: { default: true },
    name: 'result',
    components: {
      default: ResultView,
    },
  },
  {
    path: '/tournamentHistory/:zoneId/:tId',
    props: true,
    name: 'tournament-history',
    component: TournamentHistoryView,
  },
  {
    path: '/error/:code?/:zoneId?',
    name: 'error-view',
    props: { default: true },
    components: {
      default: ErrorView,
    },
  },
  {
    path: '/extern',
    children: [
      {
        path: 'login',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component: { render: () => null as any },
        beforeEnter(to, from, next) {
          // loggout handling: send user to login page?
          // TODO: this would be correct to force a tournament redirect after login - actually the sever
          // adds a /gd before which needs to be fixed before using it.
          // location.href = `/gd/login/login.xhtml?r=${location.pathname}`
          setTimeout(() => {
            // seems FF has problem when using the browser backbutton tournament will do the forward not again...
            // use replace instead of href solves this issue
            window.location.replace(
              '/gd/login/login.xhtml?web=' + encodeURIComponent(location.pathname.replace('/web', '') + location.hash)
            )
          }, 500)
        },
      },
      {
        path: 'benefits',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component: { render: () => null as any },
        beforeEnter(to, from, next) {
          const storage = new LocalStore({})
          location.href = `${storage.gd.webCtxPath}/shop-web/index.html#/benefits`
        },
      },
      {
        path: 'payout',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component: { render: () => null as any },
        beforeEnter(to, from, next) {
          window.location.href = '/gd/payout/payout.xhtml'
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const storage = new LocalStore({})
  // Redirect back to zone overview in case of illegal route
  if (to.matched.length === 0) {
    next('/')
    return
  }

  // In case user is practice player or not logged in redirect to
  // zone-overview when user is entering Tournaments through sub-routes
  // benefits page when user is on zone-overview and wants to enter a zone
  if (
    (storage.user.actorType === 'b' || !storage.user.actorType) &&
    ['tournaments', 'matching', 'result'].indexOf(to.name.toString()) !== -1
  ) {
    if (from.name === null) {
      next('/')
    } else {
      // Attention if you are wondering why a user is redirected directly to the benefits-page (LOPS-4030). This should only happen in case
      // Practice player enters zone-overview as first page and manually alters/appends path in browser's address bar to get to subsequent page, e.g. localhost:8080/result/whatever
      // As this is considered a very minor issue it won't be fixed. =)
      next('/extern/benefits')
    }
    return
  }
  next()
})

export default router
